module.exports = __webpack_public_path__ + "static/media/KinderSachenBörseFlyerA4.3f3f1231.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/KinderSachenBörseFlyerA4.pdf
// module id = 117
// module chunks = 0